import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import langSlice from './reducers/langSlice';
import domainSlice from './reducers/domainSlice';
import countrySlice from './reducers/countrySlice';
import registrationReducer from './reducers/registrationSlice';
import userTypeSlice from './reducers/userTypeSlice';
import cartReducer from './reducers/cartSlice';
import authReducer from "./reducers/authSlice";
import { persistStore, persistReducer, createMigrate } from 'redux-persist';
import { getCountryCurrency } from '../config/countries';
import storage from 'redux-persist/lib/storage';
import tenantSlice from "./reducers/tenantSlice";
import tenantUserSlice from "./reducers/tenantUserSlice"; // localStorage
import marketplaceReducer
    from "./reducers/marketplaceSlice";

import marketplaceNotificationReducer
    from "./reducers/marketplace/marketplaceNotificationSlice";

import marketplaceConversationReducer
    from "./reducers/marketplace/marketplaceConversationSlice";
import conversationNotificationReducer from "./reducers/notification/conversation/conversationNotificationSlice";

import transactionReducer
    from "./reducers/notification/transaction/transactionSlice";


const migrations = {
    // v1 : la devise est dérivée du pays d'activité (src/config/countries.js).
    1: state => state?.country
        ? {
            ...state,
            country: {
                ...state.country,
                currency: state.country.currency ??
                    getCountryCurrency(state.country.activityCountry?.value)
            }
        }
        : state
};

const persistConfig = {
    key: 'root',
    version: 1,
    migrate: createMigrate(migrations, { debug: false }),
    storage,
    whitelist: [
        'country',
        'auth',
        'lang',
        'cart',
        'auth']
};

const rootReducer = combineReducers({
    tenant: tenantSlice,
    tenantUser: tenantUserSlice,
    auth: authReducer,
  userType: userTypeSlice,
  lang: langSlice,
  domain: domainSlice,
  country: countrySlice,
  registration: registrationReducer,
  cart: cartReducer,
    marketplace: marketplaceReducer,
    marketplaceNotifications: marketplaceNotificationReducer,
    marketplaceConversation: marketplaceConversationReducer,
    conversationNotification: conversationNotificationReducer,
    transaction: transactionReducer
});

const middlewares = [thunk];

// ✅ Active Redux DevTools si dispo, sinon utilise compose
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(...middlewares))
);

export const persistor = persistStore(store);

export default store;